module.exports = {

	computed: {
		checkoutUrl: function() {
			return this.$t('checkoutUrl') + '/checkout/?loadcart='+this.$store.state.basketID+'&source=' + window.location.href;
		}
	}
	
};


// WEBPACK FOOTER //
// ./client/mixins/checkout.js